import { Input } from '@/components/Input';
import { MultipleUserInput } from '@/components/MultipleUserInput';
import { selectCompanyNumber, setCompanyNumber } from '@/context/borrower';
import { selectIsNZ } from '@/context/display';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { Abn } from '@/UserInput/Abn';
import { AbnActiveFromManual } from '@/UserInput/AbnActiveFromManual';
import { GstFrom } from '@/UserInput/GstFrom';
import { NumberOfDirectors } from '@/UserInput/NumberOfDirectors';

interface Props {
    baseId: string;
    showErrors: boolean;
}

export function BusinessManualSection({
    baseId,
    showErrors,
}: Props): JSX.Element {
    const isNZ = useAppSelector(selectIsNZ);
    const companyNumber = useAppSelector(selectCompanyNumber);
    const dispatch = useAppDispatch();

    return (
        <>
            <Abn baseId={baseId} showErrors={showErrors} disabled={false} />

            {isNZ && (
                <MultipleUserInput>
                    <Input
                        title='Company Number'
                        placeholder='Enter Company Number'
                        showErrors={showErrors}
                        id={`${baseId}-input-companyNumber`}
                        value={companyNumber ?? ''}
                        onChange={(value): void => {
                            if (typeof value === 'boolean') return;
                            dispatch(setCompanyNumber(value));
                        }}
                    />
                    <div className='hidden' />
                </MultipleUserInput>
            )}
            <MultipleUserInput>
                <AbnActiveFromManual baseId={baseId} showErrors={showErrors} />
                <GstFrom baseId={baseId} showErrors={showErrors} />
            </MultipleUserInput>
            <MultipleUserInput>
                <NumberOfDirectors baseId={baseId} showErrors={showErrors} />
                <div className='hidden' />
            </MultipleUserInput>
        </>
    );
}
